import { type Component, For } from "solid-js";
import styles from "./Navbar.module.css";
import { detailedUseCasesConfig, type NavSection, type NavLink } from "../navbarConfig";
import { classNames } from "@core/lib/classNames";

// New component for individual links
const UseCaseLink: Component<NavLink> = (props) => {
  return (
    <a class="text-base leading-perfect-fifth text-white hover:text-pink-300 transition-colors" href={props.href}>
      {props.label}
    </a>
  );
};

// New component for a category of use cases
const UseCaseCategory: Component<{ category: NavSection }> = (props) => {
  return (
    <div class="grid gap-y-3 auto-rows-min grid-cols-1">
      <h4
        class={classNames(
          styles["text-size-small"],
          styles["text-weight-semibold"],
          styles["text-brand-purple-static"],
        )}
      >
        {props.category.title}
      </h4>
      <For each={props.category.links}>{(link) => <UseCaseLink href={link.href} label={link.label} />}</For>
    </div>
  );
};

export const UseCasesDropdownContent: Component = () => {
  // classNames and styles are available in this Navbar.tsx's scope
  // styles is imported from "./Navbar.module.css"

  return (
    <div class="grid grid-cols-[1fr_1.2fr_1fr] gap-x-10 gap-y-12 w-[43rem]">
      <For each={detailedUseCasesConfig}>{(category) => <UseCaseCategory category={category} />}</For>
    </div>
  );
};
